import { useEffect } from 'react';

export function Modal({ open, title, onClose, children, actions }) {
  useEffect(()=>{
    function esc(e){ if(e.key==='Escape') onClose?.(); }
    if(open) window.addEventListener('keydown', esc);
    return ()=> window.removeEventListener('keydown', esc);
  },[open,onClose]);
  if(!open) return null;
  return (
    <div style={backdrop} onMouseDown={onClose}>
      <div style={dialog} onMouseDown={e=>e.stopPropagation()}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'0.75rem'}}>
          <h3 style={{margin:0, fontSize:'1rem'}}>{title}</h3>
          <button onClick={onClose} className="btn outline" style={{padding:'.25rem .6rem'}}>X</button>
        </div>
        <div style={{maxHeight:'50vh', overflowY:'auto'}}>{children}</div>
        {actions && <div style={{marginTop:'1rem', display:'flex', justifyContent:'flex-end', gap:'.5rem'}}>{actions}</div>}
      </div>
    </div>
  );
}

const backdrop = { position:'fixed', inset:0, background:'rgba(0,0,0,.25)', display:'flex', justifyContent:'center', alignItems:'flex-start', padding:'10vh 1rem', zIndex:5000 };
const dialog = { background:'#fff', border:'1px solid var(--color-border)', borderRadius:8, padding:'1rem 1.2rem', width:'min(600px,100%)', boxShadow:'var(--shadow-md)' };
